import { toJSONSchema, z } from "zod";

const zEnumerable = z.union([z.string(), z.number(), z.array(z.string()), z.array(z.number()), z.null()]).optional();

const zJsonQuery = z
  .object({
    path: z.array(z.string()),
    equals: zEnumerable,
    array_contains: zEnumerable,
    not: zEnumerable,
    string_starts_with: z.string().optional(),
    string_ends_with: z.string().optional(),
  })
  .passthrough();

export const zEvidenceImporterDefinition = z
  .object({
    version: z.string().optional(),
    evidenceIdResolver: z
      .object({
        metadata: zJsonQuery.optional(),
        properties: zJsonQuery.optional(),
      })
      .passthrough()
      .optional(),
    metadataDefaults: z.record(z.string(), z.unknown()).optional(),
    propertiesMappings: z
      .array(
        z
          .object({
            sourcePropertyName: z.string(),
            targetPropertyName: z.string().nullable().optional(),
          })
          .passthrough(),
      )
      .optional(),
    metadataMappings: z
      .array(
        z
          .object({
            sourceMetadataName: z.string(),
            targetMetadataName: z.string(),
          })
          .passthrough(),
      )
      .optional(),
    dataSourceFilter: zJsonQuery.optional(),
  })
  .passthrough();

export const evidenceImporterDefinitionJsonSchema = {
  ...toJSONSchema(zEvidenceImporterDefinition),
  additionalProperties: false,
};

export const EVIDENCE_IMPORTER_DEFINITION_KNOWN_KEYS = [
  "version",
  "evidenceIdResolver",
  "metadataDefaults",
  "propertiesMappings",
  "metadataMappings",
  "dataSourceFilter",
];
